import { APP_NAME, APP_SUBTITLE } from '../data/knowledgeBase';
import yaraKnowledgeGrows from '../assets/yara-knowledge-grows.png';

export const Header = () => {
  return (
    <header className="hero">
      <div className="hero__header">
        <div className="hero__content">
          <h1>{APP_NAME}</h1>
          <p className="hero__subtitle">{APP_SUBTITLE}</p>
          <p className="hero__description">
            Prepare reuniões com foco em produtividade, rentabilidade, margem por hectare e redução de risco, conduzindo a conversa para valor, ciência agronômica e retorno sobre investimento, nunca para guerra de preço.
          </p>
          <div className="hero__highlights">
            <span>OPC | Direção estratégica</span>
            <span>SPIN | Diagnóstico consultivo</span>
            <span>EPA | Provocação de valor</span>
            <span>Senoide | Narrativa de decisão</span>
          </div>
        </div>
        <div className="hero__brand" aria-label="Yara">
          <img src={yaraKnowledgeGrows} alt="Yara Knowledge grows" className="hero__logo" />
        </div>
      </div>
    </header>
  );
};
